<template>
    <svg :class="{active}" viewBox="0 0 140.947 139.606" class="logo-icon">
        <g transform="matrix(1.33333 0 0 -1.33333 -822.193 2491.136)">
            <g>
                <path class="logo-icon-path-1" d="M665.78 1774.648L655.033 1764l-10.75 10.648 10.75 10.643zM722 1829.258l-38.602-38.235-11.004 10.898 38.603 38.236zM694.717 1857.35l-10.748-10.641-10.748 10.641 10.748 10.65zM666.606 1829.256l-38.6-38.233L617 1801.928l38.6 38.229z" fill="none" stroke-width=".5" stroke-miterlimit="10"/>
                <path class="logo-icon-path-2" d="M627.746 1819.685L617 1830.33l10.746 10.646 10.75-10.646zM683.71 1764.82l-38.6 38.235 11.003 10.898 38.603-38.232zM711.254 1791.024l-10.75 10.646 10.75 10.645L722 1801.67zM683.71 1818.047l-38.6 38.235 11.005 10.899 38.601-38.229z" fill="none" stroke-width=".5" stroke-miterlimit="10"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['active']
}
</script>
